import {useQuery} from 'react-query';
import RefreshCheckApi from '../../../../communication_system/axios_apis/refresh_check/refresh_check_api';

/**sales overview data */
export const useSalesQuery = (dateType, business = 'all', startDate, endDate, isEnabled) => {
    const defaultPath = '/v2/revenue';
    let path = '';
    if (dateType === 'custom' && startDate && endDate) {
        path = `${defaultPath}?start_date=${startDate}&end_date=${endDate}&business=${business}`;
    } else {
        path = defaultPath + '/' + dateType + `?business=${business}`;
    }

    return useQuery({
        queryKey: ['salesOverview', dateType, business, startDate, endDate],
        queryFn: async () => {
            const response = await RefreshCheckApi.get(path);
            if (!response.data.ok) {
                throw new Error('Network response was not ok');
            }

            return response.data.data;
        },
        staleTime: 5 * 60 * 1000,

        enabled: isEnabled,
        refetchOnWindowFocus: false,

        retry: 1,
    });
};
